<i18n src="@/locales/modules/DeviceAccessoryTranslate.json"></i18n>

<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="
			setDialogHide => {
				dataImgFile = null;
				handleCloseDialog(setDialogHide, isFormDirty);
			}
		"
		class="custom-dialog"
		:visible.sync="isPopupActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">{{ $t(id ? "UpdateAccessory" : "CreateAccessory", { accessoryTypeName: this.accessoryTypeName }) }}</h4>
			<p class="text-base text-black font-medium">{{ data.device ? data.device.name : "" }}</p>
		</div>
		<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="p-6">
				<!-- NAME -->
				<div class="mb-5">
					<label for class="vs-input--label">
						{{ $t("AccessoryName", { accessoryTypeName: this.accessoryTypeName }) }}
						<span class="text-danger">*</span>:
					</label>
					<cbs-input
						v-model="name"
						class="w-full"
						name="name"
						:data-vv-as="$t('AccessoryName', { accessoryTypeName: this.accessoryTypeName })"
						:placeholder="`${$t('Actions.Input')} ${$t('AccessoryName', { accessoryTypeName: this.accessoryTypeName })}`"
						v-validate="'required'"
					/>
					<span class="text-danger text-sm break-normal" v-show="errors.has('name')">{{ errors.first("name") }}</span>
				</div>

				<!-- MaintainHour -->
				<div class="mb-5">
					<label for class="vs-input--label"> {{ $t("MaintainHour") }}: </label>
					<cbs-input
						type="number"
						v-model="maintainHrs"
						class="w-full"
						min="0"
						name="maintainHrs"
						:placeholder="`${$t('Actions.Input')} ${$t('MaintainHour')}`"
						v-validate="{ numeric: true, min_value: 0 }"
						:data-vv-as="$t('MaintainHour')"
					/>
					<span class="text-danger text-sm break-normal" v-show="errors.has('maintainHrs')">{{ errors.first("maintainHrs") }}</span>
				</div>

				<!-- CODE -->
				<div class="mb-5">
					<label for class="vs-input--label">
						{{ $t("AccessoryCode", { accessoryTypeName: this.accessoryTypeName }) }}
						:
					</label>
					<cbs-input
						v-model="code"
						class="w-full"
						name="code"
						:data-vv-as="$t('AccessoryCode')"
						:placeholder="`${$t('Actions.Input')} ${$t('AccessoryCode', { accessoryTypeName: this.accessoryTypeName })}`"
					/>
					<span class="text-danger text-sm break-normal" v-show="errors.has('code')">{{ errors.first("code") }}</span>
				</div>

				<CbsTags v-model="tags" />

				<!-- CHARACTERICTICS -->
				<div class="my-5">
					<label for class="vs-input--label">
						{{ $t("Characteristics") }}
						:
					</label>
					<cbs-textarea
						type="text"
						:autosize="{ minRows: 3, maxRows: 4 }"
						class="m-0"
						name="characteristics"
						:data-vv-as="$t('Characteristics')"
						:placeholder="$t('Placeholder.InputCharacteristics', { accessoryTypeName: this.accessoryTypeName })"
						v-model="characteristics"
					/>
					<span class="text-danger text-sm break-normal" v-show="errors.has('characteristics')">{{ errors.first("characteristics") }}</span>
				</div>

				<!-- Attach file -->
				<div class="mt-5 mb-3">
					<label for class="vs-input--label">{{ $t("Attachments") }}:</label>
					<cbs-upload-ref v-model="files" />
					<p class="italic font-weight-normal text-gray-3">{{ $t("CanAttachPicturesOrDocumentsRelatedToTheDevice", { target: this.accessoryTypeName }) }}</p>
				</div>
			</div>
		</PerfectScrollbar>

		<div class="flex justify-center" slot="footer">
			<vs-button :type="data.id ? 'filled' : 'border'" class="w-full sm:w-1/3 mb-3 sm:mb-0 sm:mr-6 font-bold" @click.stop="submitData(!!data.id)">
				{{ data.id ? $t("Actions.Save") : $t("Actions.SaveAndRecreate") }}
			</vs-button>
			<vs-button v-show="!data.id" class="w-full sm:w-1/3 font-bold" @click.stop="submitData">{{ $t("Actions.Submit") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import _ from "lodash";
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef";
import CbsTags from "@/components/cbs-tags/CbsTags";

export default {
	props: {
		isPopupActive: {
			type: Boolean,
			required: true
		},
		data: {
			type: Object,
			default: () => {}
		}
	},
	components: { CbsUploadRef, CbsTags },
	data() {
		return {
			id: null,
			name: "",
			code: "",
			characteristics: "",
			description: "",
			accessoryCurrentValue: 0,
			accessoryWarningLimit: null,
			accessoryAlertLimit: null,
			dataImg: null,
			dataImgFile: null,
			sensorType: "none",
			sensorCode: "",
			sensorLimitLevel: null,
			sensorAlertLimit: null,
			sensorWarningLimit: null,
			isSensorActive: false,
			isSensorCounter: false,
			isConfigAccessory: false,

			initFormData: {},
			isFormDirty: false,
			isResetAccessoryCurrentValue: false,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			},
			files: [],
			maintainHrs: "",
			tags: []
		};
	},
	watch: {
		isPopupActive(val) {
			if (!val) return;

			const { id, name, code, image, is_configured, readableExtraProperty, readableProperties, description, warning_threshold, alert_threshold, current, files, maintain_hrs, tags } = this.data;
			if (!this.data.id) {
				this.initValues();
			} else {
				this.id = id;
				this.name = name;
				this.code = code;
				this.accessoryCurrentValue = current || 0;
				this.dataImg = image ? image.path : null;
				this.dataImgFile = this.dataImg;
				this.characteristics = readableExtraProperty;
				this.description = description;
				this.accessoryAlertLimit = alert_threshold;
				this.accessoryWarningLimit = warning_threshold;
				this.sensorType = _.get(readableProperties, "sensor_type") || "none";
				this.sensorCode = _.get(readableProperties, "sensor_code") || "";
				this.isSensorActive = _.get(readableProperties, "sensor_active") || false;
				this.isConfigAccessory = is_configured || false;
				this.isSensorCounter = _.get(readableProperties, "sensor_is_counter") || false;
				this.sensorWarningLimit = _.get(readableProperties, "sensor_warning_threshold");
				this.sensorAlertLimit = _.get(readableProperties, "sensor_alert_threshold");
				this.files = files;
				this.maintainHrs = maintain_hrs && maintain_hrs > 0 ? maintain_hrs : "";
				this.tags = tags ? tags : [];
			}

			this.isFormDirty = false;
			this.initFormData = {
				id: this.id,
				name: this.name,
				code: this.code,
				isConfigAccessory: this.isConfigAccessory,
				accessoryCurrentValue: this.accessoryCurrentValue,
				characteristics: this.characteristics,
				description: this.description,
				dataImg: this.dataImg,
				dataImgFile: this.dataImgFile,
				sensorType: this.sensorType,
				sensorCode: this.sensorCode,
				sensorLimitLevel: this.sensorLimitLevel,
				isSensorActive: this.isSensorActive,
				accessoryAlertLimit: this.accessoryAlertLimit,
				accessoryWarningLimit: this.accessoryWarningLimit,
				isSensorCounter: this.isSensorCounter,
				sensorWarningLimit: this.sensorWarningLimit,
				sensorAlertLimit: this.sensorAlertLimit,
				isResetAccessoryCurrentValue: this.isResetAccessoryCurrentValue,
				files: this.files,
				maintainHrs: this.maintainHrs,
				tags: this.tags
			};
		},
		dataImg() {
			if (!this.dataImg) {
				this.dataImgFile = null;
			}
		},
		computedFormData: {
			handler: function(newVal) {
				if (!this.isFormDirty && !_.isEqual(newVal, this.initFormData) && newVal.id === this.initFormData.id) {
					this.isFormDirty = true;
				}
			},
			deep: true
		},
		sensorType() {
			this.sensorCode = this.initFormData.sensorCode;
			this.isSensorActive = this.initFormData.isSensorActive;
			this.isSensorCounter = this.initFormData.isSensorCounter;
			this.sensorAlertLimit = this.initFormData.sensorAlertLimit;
			this.sensorWarningLimit = this.initFormData.sensorWarningLimit;
		}
	},
	methods: {
		initValues() {
			if (this.data.id) return;
			this.id = null;
			this.name = "";
			this.code = "";
			this.isConfigAccessory = false;
			this.accessoryCurrentValue = 0;
			this.characteristics = "";
			this.description = "";
			this.dataImg = null;
			this.sensorType = "none";
			this.sensorCode = "";
			this.sensorLimitLevel = null;
			this.isSensorActive = false;
			this.accessoryAlertLimit = null;
			this.accessoryWarningLimit = null;
			this.isSensorCounter = null;
			this.sensorWarningLimit = null;
			this.sensorAlertLimit = null;
			this.files = [];
			this.maintainHrs = "";
			this.tags = [];
			this.$validator.reset();
		},
		handleCreateOrUpdateSuccess(isCloseForm) {
			this.initValues();
			if (isCloseForm) {
				this.$emit("closePopup");
			}
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: this.$t(`${this.id ? "UpdateAccessorySuccessful" : "CreateAccessorySuccessful"}`, { accessoryTypeName: this.accessoryTypeName })
				}
			});
		},
		async handleCreateOrUpdateAccessory(dataObj, isCloseForm) {
			try {
				this.$vs.loading();
				if (this.id) {
					await this.$store.dispatch("deviceManagement/updateAccessory", {
						...dataObj,
						id: this.id
					});
				} else {
					await this.$store.dispatch("deviceManagement/addAccessory", {
						...dataObj,
						device_id: this.data.deviceId
					});
				}

				this.handleCreateOrUpdateSuccess(isCloseForm);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		submitData(isCloseForm = false) {
			this.$validator.validateAll().then(result => {
				if (result) {
					const _files = this.files.map(file => file.id);
					const dataObj = {
						name: this.name,
						code: this.code,
						description: this.description,
						warning_threshold: this.accessoryWarningLimit,
						alert_threshold: this.accessoryAlertLimit,
						properties: JSON.stringify({
							extra: this.characteristics,
							sensor_type: this.sensorType,
							sensor_alert_threshold: this.sensorType !== "none" ? this.sensorAlertLimit : "",
							sensor_warning_threshold: this.sensorType !== "none" ? this.sensorWarningLimit : "",
							sensor_active: this.sensorType !== "none" ? this.isSensorActive : "",
							sensor_code: this.sensorType !== "none" ? this.sensorCode : "",
							sensor_is_counter: this.sensorType !== "none" ? this.isSensorCounter : ""
						}),
						type_id: this.data.accessoryType,
						files: _files,
						maintain_hrs: this.maintainHrs,
						tag_ids: this.tags
					};
					if (this.id && this.isResetAccessoryCurrentValue) {
						dataObj.is_reset_counter = this.isResetAccessoryCurrentValue;
					}
					if (!this.isConfigAccessory) {
						dataObj.warning_threshold = null;
						dataObj.alert_threshold = null;
					}
					if (JSON.stringify(this.dataImgFile) !== JSON.stringify(this.initFormData.dataImgFile)) {
						dataObj.image = this.dataImgFile;
						dataObj.image_changed = true;
					}
					this.handleCreateOrUpdateAccessory(dataObj, isCloseForm);
				}
			});
		},
		updateCurrImg(input) {
			if (input.target.files && input.target.files[0]) {
				var reader = new FileReader();
				reader.onload = e => {
					this.dataImgFile = input.target.files[0];
					this.dataImg = e.target.result;
				};
				reader.readAsDataURL(input.target.files[0]);
			}
		},
		resetAccessoryCurrentValue() {
			this.accessoryCurrentValue = 0;
			this.isResetAccessoryCurrentValue = true;
		}
	},
	computed: {
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			}
		},
		computedFormData() {
			return {
				id: this.id,
				name: this.name,
				code: this.code,
				isConfigAccessory: this.isConfigAccessory,
				accessoryCurrentValue: this.accessoryCurrentValue,
				characteristics: this.characteristics,
				description: this.description,
				dataImg: this.dataImg,
				dataImgFile: this.dataImgFile,
				sensorType: this.sensorType,
				sensorCode: this.sensorCode,
				sensorLimitLevel: this.sensorLimitLevel,
				isSensorActive: this.isSensorActive,
				accessoryAlertLimit: this.accessoryAlertLimit,
				accessoryWarningLimit: this.accessoryWarningLimit,
				isSensorCounter: this.isSensorCounter,
				sensorWarningLimit: this.sensorWarningLimit,
				sensorAlertLimit: this.sensorAlertLimit,
				isResetAccessoryCurrentValue: this.isResetAccessoryCurrentValue,
				files: this.files,
				maintainHrs: this.maintainHrs,
				tags: this.tags
			};
		},
		sensorUnit() {
			if (this.sensorType === "temperature") {
				return "Celsius";
			}

			if (this.sensorType === "electric") {
				return "Hour";
			}

			return "";
		},
		accessoryWarningLimitRules() {
			const rules = {
				required: !!this.isConfigAccessory,
				decimal: true
			};
			if (!_.isNull(this.accessoryAlertLimit)) {
				rules["isSmaller"] = {
					name: this.$t("AccessoryLimitAlertLevel"),
					value: Number(this.accessoryAlertLimit)
				};
			}
			return rules;
		},
		sensorWarningLimitRules() {
			const rules = {
				decimal: true
			};
			if (this.sensorAlertLimit || this.sensorAlertLimit === 0) {
				rules["isSmaller"] = {
					name: this.$t("SensorLimitAlertLevel"),
					value: Number(this.sensorAlertLimit)
				};
			}
			return rules;
		},
		accessoryTypeName() {
			switch (this.data.accessoryType) {
				case this.$constant.ACCESSORY_TYPE.ACCESSORY:
					return this.$t("Accessory").toLowerCase();

				case this.$constant.ACCESSORY_TYPE.MATERIAL:
					return this.$t("Material").toLowerCase();

				case this.$constant.ACCESSORY_TYPE.REMIND_WORK:
					return this.$t("RemindWork").toLowerCase();
				default:
					break;
			}
		}
	}
};
</script>
